import React from "react";
import { createBrowserRouter } from "react-router-dom";
import Viewer from "../views/Viewer";
import NotFound from "../views/404";

export const router = createBrowserRouter([
  {
    path: ":streamCode",
    element: <Viewer />,
  },
  { path: "*", element: <NotFound /> }, // Not found? Go to default route
]);
